var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.1 12L18.5 13.625L13.15 8.275L13.15 20.1L10.85 20.1L10.85 8.27501L5.50002 13.625L3.90002 12L12 3.9L20.1 12Z","fill":"currentColor"}));
}

ArrowUp.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
